class DueDateType {
  /**
   * Index / Get listing of option to Filter properties by
   * @returns {*}
   */
  static list() {
    return {
      data: {
        data: [
          {
            name: 'FRA Expiry Date',
            value: 'dueDate',
          },
          {
            name: 'Programme Due Date',
            value: 'programDueDate',
          },
        ],
      },
    };
  }
}

export default DueDateType;
